import appGlobalScript from '/Users/edyavendano/Documents/Edy/Github/ionic-selectable/packages/core/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
